import React from "react";
import cx from "classnames";
import styles from "./Paragraph.module.scss";

export interface ParagraphProps {
  className?: string;
  size?: "f1" | "f2" | "f3" | "f4" | "f5" | "f6";
  lineHeight?: "lh-title" | "lh-solid" | "lh-copy";
  flushTop?: boolean;
  flushBottom?: boolean;
  flush?: boolean;
}

const Paragraph: React.FC<ParagraphProps> = ({
  className,
  children,
  size,
  lineHeight = "lh-copy",
  flush,
  flushTop,
  flushBottom,
}) => {
  return (
    <p
      className={cx(styles.heading, className, size, lineHeight, {
        [styles.flushTop]: flushTop || flush,
        [styles.flushBottom]: flushBottom || flush,
      })}
    >
      {children}
    </p>
  );
};

export default Paragraph;
